import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FC } from "react";
import {transformSalesHistoryObject } from "../../../utils/helper";


export interface HoverItem {
  [key: string]: number;
}



interface HoverTableProps {
  historyData: HoverItem;
  forecastData: HoverItem;
  rowData: any

}

const HoverTable: FC<HoverTableProps> = ({ historyData, forecastData, rowData }) => {

  const sales_history_data = transformSalesHistoryObject(historyData)
  const sales_forecast_data = transformSalesHistoryObject(forecastData)

  return (<>
    <div className="dialog-datatable-modal">
      <div className="dialog-datatable-head">
        <p><b><span>{rowData.city_name}</span> </b> </p>

      </div>
      <div className="dialog-datatable-wrap">
        <div className="dialog-datatable">
          {/* <div className="table-name">Sales History</div> */}
          <DataTable value={sales_history_data} scrollable stripedRows>
            <Column field="Date" header="History Range" />
            <Column field="Quantity" header="Amount" />
          </DataTable>
  
        </div>
        <div className="dialog-datatable">
        <DataTable value={sales_forecast_data} scrollable stripedRows>
            <Column field="Date" header="Forecast Range" />
            <Column field="Quantity" header="Amount" />
          </DataTable>
        </div>
      </div>
    </div>
  </>
  );
};

export default HoverTable;
